import globalEventService from '~/services/globalEventService';
import { data } from '~/stores/data/Data';
import { getQueryParameterByName } from '~/utils/runEnvironmentUtil';

import Actions from './Actions';
import { stores } from './Stores';
import { uiState } from './UiState';
import Utils from './Utils';

const utils = new Utils();

const actions = new Actions(stores, utils);

stores.init(actions);

const Context = {
  actions,
  stores,
  uiState,
  utils,
  data,
  globalEventService,
};

interface IdleDetector {
  new ();
  requestPermission(): Promise<'granted' | 'rejected'>;
}

declare global {
  interface Window {
    _____NEW_STATE_____: any;
    __FILE_NAME__: '400' | '404' | '500' | 'orgs' | 'unauthorized' | 'unauthorized_ip';
    isFileDialogOpened: boolean;
    __localeId__: string;
    __timezoneId__: string;
    IdleDetector?: IdleDetector;
  }

  interface Navigator {
    setAppBadge?: (count: number) => Promise<null>;
  }
}

if (process.env.NODE_ENV !== 'production' || getQueryParameterByName('_debug') === 'true') {
  window._____NEW_STATE_____ = Context;
  window.R = require('ramda');
}

export default Context;
